import { MenuItem, styled } from '@mui/material';

export const MenuItemWithAction = styled(MenuItem)(() => ({
  padding: '8px',
  display: 'inline-block'
}));
